<template>
  <div class="col-sm-12 col-xl-6">
    <div class="trade-add-card h-100">
      <h6 class="mb-4">Add Trade</h6>
      <form @submit.prevent="onSubmit">
        <div class="form-floating mb-3">
          <select
            class="form-select"
            id="select-type"
            aria-label="Select Sector"
            name="type"
            v-model="form.type_id"
          >
            <option selected value="">Select Type</option>
            <option v-for="(value, key) in typeOptions" :key="key" :value="key">
              {{ value }}
            </option>
          </select>
        </div>

        <div class="form-floating mb-3">
          <select
            class="form-select"
            id="select-sector"
            aria-label="Select Sector"
            name="stock_id"
            v-model="form.stock_id"
          >
            <option selected value="">Select Stoke</option>
            <option
              v-for="(value, key) in this.stokeList"
              :key="key"
              :value="key"
            >
              {{ value }}
            </option>
          </select>
        </div>

        <div class="form-floating mb-3">
          <input
            type="number"
            v-model="form.amount"
            name="amount"
            class="form-control"
            id="amount"
            placeholder="Amount"
          />
          <label for="name">Amount</label>
        </div>

        <div class="form-floating mb-3">
          <input
            type="number"
            v-model="form.qty"
            name="qty"
            class="form-control"
            id="qty"
            placeholder="Quantity"
          />
          <label for="qty">Quantity</label>
        </div>

        <div class="form-floating mb-3">
          <input
            type="number"
            v-model="form.buy"
            name="buy"
            class="form-control"
            id="buy"
            placeholder="Buy"
          />
          <label for="name">Buy</label>
        </div>

        <div class="form-floating mb-3">
          <input
            type="number"
            v-model="form.sell"
            name="sell"
            class="form-control"
            id="sell"
            placeholder="Sell"
          />
          <label for="name">Sell</label>
        </div>

        <div class="form-floating mb-3">
          <input
            type="number"
            v-model="form.profit_loss"
            name="profit_loss"
            class="form-control"
            id="profit_loss"
            placeholder="Sell"
          />
          <label for="name">Profit Loss</label>
        </div>

        <div class="form-floating mb-3">
          <input
            type="date"
            v-model="form.perches_date"
            name="perches_date"
            class="form-control"
            id="perches-date"
            placeholder="Perches Date"
          />
          <label for="perches-date">Perches Date</label>
        </div>

        <div class="form-floating mb-3">
          <textarea
            class="form-control"
            v-model="form.comments"
            name="comments"
            placeholder="Leave a comment here"
            id="floatingTextarea"
            style="height: 150px"
          ></textarea>
          <label for="floatingTextarea">Comments</label>
        </div>
        <div class="form-floating mb-3">
          <button
            :disabled="v$.form.$invalid"
            type="submit"
            @click="addNewTrade()"
            class="btn btn-primary"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
  
  <script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { useAlertStore } from "@/stores";
import { fetchWrapper } from '@/helpers';

export default {
  name: "add-trade",
  setup() {
    return {
      v$: useVuelidate(),
      alertStore$: useAlertStore(),
    };
  },
  data() {
    return {
      form: {
        type_id: "",
        stock_id: "",
        amount: "",
        qty: "",
        buy: "",
        sell: "",
        profit_loss: "",
        perches_date: "",
        comments: "",
      },
      typeOptions: { 1: "Intraday", 2: "Swing Trade", 3: "Future and Option" },
      stokeList: "",
    };
  },
  validations() {
    return {
      form: {
        type_id: { required },
        stock_id: { required },
        buy: { required },
        sell: { required },
      },
    };
  },
  methods: {
    addNewTrade() {
      try {
        fetchWrapper.post("api/trade/add-new", this.form).then((response) => {
          if (response.data.success) {
            this.alertStore$.success("New Trade add successfully.");
          } else {
            this.alertStore$.error(response.message);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getStokeList() {
      return await this.$dataHelper.stokePairs(fetchWrapper, "stock_id", "name");
    },
  },
  async mounted() {
    this.stokeList = await this.getStokeList();
  },
};
</script>

<style scoped>
.trade-add-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 24px;
}
</style>